// La moneda del anuncio: una sola para el anuncio, sus alojamientos y sus tarifas.
export const monedaAnuncio = {
  chipTitle: "Listing currency",
  change: "Change",
  mismatchDot: "This listing's currencies don't match",
  channexText: "This listing is connected to Channex. A rate's currency can't be changed there: it has to be recreated. Write to us and we'll do it without interrupting your OTA sales.",
  channexOnly: "It's connected to Channex: it can only use {currency}, the currency of its rates there.",
  modal: {
    title: "Listing currency",
    lead: "This is the currency you charge guests of this listing in.",
    scope: "It changes at once for the listing, all its properties and its rates. Payment links, the AI agent and late checkout will use this currency.",
    label: "Currency",
    mismatch: "Right now they don't match: the listing says {listing} and its properties charge in {units}. Saving will put everything in the same one.",
    channexTitle: "It can't be changed from here",
    cancel: "Cancel",
    close: "Got it",
    save: "Save",
    saving: "Saving…",
    saved: "Listing currency updated to {currency}.",
    error: "The currency couldn't be changed. Please try again.",
  },
  sugerencia: {
    titleCountry: "This listing charges in {current}",
    textCountry: "In {country} people usually pay in {suggested}. If you change it, payment links, the AI agent and late checkout will use {suggested}.",
    titleMismatch: "This listing's currencies don't match",
    textMismatch: "The listing says {listing} and its properties charge in {units}. Keep just one so what the AI quotes and what is charged are the same.",
    useSuggested: "Change to {currency}",
    other: "Choose another",
    keep: "Keep {currency}",
  },
};
